module.exports = __webpack_public_path__ + "Server-Warning.OfflineDrop.e53eb60fc2c30e95dda3397238ce9db6.hashedasset.svg";